/* eslint-disable */

import * as runtime from '../runtime';
import type {
  CreateDeferredMembershipPurchaseDto,
  CreateDeferredSetupIntentDto,
  DeferredBookingAccessDto,
  DeferredMembershipPreviewDto,
  DeferredMembershipPurchaseDto,
  DeferredSetupIntentDto,
  PrepareDeferredBookingDto,
  PreviewDeferredMembershipDto,
} from '../models';

export interface PrepareDeferredBookingRequest {
  orgId: number;
  prepareDeferredBookingDto: PrepareDeferredBookingDto;
}

export interface PrepareDeferredBookingGuestRequest {
  orgId: number;
  prepareDeferredBookingDto: PrepareDeferredBookingDto;
}

export interface PreviewDeferredMembershipRequest {
  orgId: number;
  previewDeferredMembershipDto: PreviewDeferredMembershipDto;
}

export interface PreviewDeferredMembershipGuestRequest {
  orgId: number;
  previewDeferredMembershipDto: PreviewDeferredMembershipDto;
}

export interface CreateSetupIntentRequest {
  orgId: number;
  createDeferredSetupIntentDto: CreateDeferredSetupIntentDto;
}

export interface CreateSetupIntentGuestRequest {
  orgId: number;
  createDeferredSetupIntentDto: CreateDeferredSetupIntentDto;
}

export interface CreateDeferredMembershipPurchaseRequest {
  orgId: number;
  createDeferredMembershipPurchaseDto: CreateDeferredMembershipPurchaseDto;
}

export interface CreateDeferredMembershipPurchaseGuestRequest {
  orgId: number;
  createDeferredMembershipPurchaseDto: CreateDeferredMembershipPurchaseDto;
}

export class DeferredMembershipsApi extends runtime.BaseAPI {

  async prepareDeferredBooking(requestParameters: PrepareDeferredBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeferredBookingAccessDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/deferred-memberships/org/${encodeURIComponent(String(requestParameters.orgId))}/prepare-booking`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.prepareDeferredBookingDto,
    }, initOverrides);
    return response.json();
  }

  async prepareDeferredBookingGuest(requestParameters: PrepareDeferredBookingGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeferredBookingAccessDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/deferred-memberships/org/${encodeURIComponent(String(requestParameters.orgId))}/prepare-booking/guest`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.prepareDeferredBookingDto,
    }, initOverrides);
    return response.json();
  }

  async previewDeferredMembership(requestParameters: PreviewDeferredMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeferredMembershipPreviewDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/deferred-memberships/org/${encodeURIComponent(String(requestParameters.orgId))}/preview`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.previewDeferredMembershipDto,
    }, initOverrides);
    return response.json();
  }

  async previewDeferredMembershipGuest(requestParameters: PreviewDeferredMembershipGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeferredMembershipPreviewDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/deferred-memberships/org/${encodeURIComponent(String(requestParameters.orgId))}/guest-preview`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.previewDeferredMembershipDto,
    }, initOverrides);
    return response.json();
  }

  async createSetupIntent(requestParameters: CreateSetupIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeferredSetupIntentDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/deferred-memberships/org/${encodeURIComponent(String(requestParameters.orgId))}/setup-intent`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createDeferredSetupIntentDto,
    }, initOverrides);
    return response.json();
  }

  async createSetupIntentGuest(requestParameters: CreateSetupIntentGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeferredSetupIntentDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/deferred-memberships/org/${encodeURIComponent(String(requestParameters.orgId))}/guest-setup-intent`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createDeferredSetupIntentDto,
    }, initOverrides);
    return response.json();
  }

  async createDeferredMembershipPurchase(requestParameters: CreateDeferredMembershipPurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeferredMembershipPurchaseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/deferred-memberships/org/${encodeURIComponent(String(requestParameters.orgId))}/purchases`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createDeferredMembershipPurchaseDto,
    }, initOverrides);
    return response.json();
  }

  async createDeferredMembershipPurchaseGuest(requestParameters: CreateDeferredMembershipPurchaseGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeferredMembershipPurchaseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/deferred-memberships/org/${encodeURIComponent(String(requestParameters.orgId))}/guest-purchases`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createDeferredMembershipPurchaseDto,
    }, initOverrides);
    return response.json();
  }

}
